export const HomeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
  >
    <path
      fill="currentColor"
      d="M3 13h.5a.5.5 0 0 1 .5.5V20c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-6.5a.5.5 0 0 1 .5-.5h.5a1 1 0 0 0 .707-1.707l-9-9a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13Zm7.5 7a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3Zm1.147-15.232a.5.5 0 0 1 .707 0l5.5 5.5a.5.5 0 0 1 .146.353v4.38l.001 4.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V15c0-1.104-.898-2-2-2h-4c-1.104 0-2 .896-2 2v4.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V10.62a.5.5 0 0 1 .146-.353l5.5-5.5Z"
    />
  </svg>
);
